import styled from 'styled-components';
import { Button } from 'reactstrap';
import { LargeColumn, FullColumn } from '@bit/wavfichacerta.fichacerta.shared-styles.columns';

export const LoginResponseMessageContainer = styled(LargeColumn)`
  text-align: center;
  padding: 0.65rem 1rem;
  max-width: 100%;
  flex: 0 0 100%;
  font-size: 0.8125rem;
  line-height: 1.45;
  margin-bottom: 1rem;
  border-radius: 12px;
  font-weight: 500;
  /* Login card is dark — theme purple/red are too dark for text on this surface */
  border: 1px solid
    ${props =>
      props.color === 'color_red'
        ? 'rgba(252, 165, 165, 0.65)'
        : 'rgba(147, 197, 253, 0.55)'};
  color: ${props =>
    props.color === 'color_red' ? '#fecaca' : '#e8f0ff'};
  background: ${props =>
    props.color === 'color_red'
      ? 'rgba(220, 38, 38, 0.2)'
      : 'rgba(59, 130, 246, 0.22)'};

  svg {
    margin-top: -3px !important;
    margin-left: 6px !important;
    vertical-align: middle;

    path {
      fill: #e04f5f !important;
    }
  }
`;

export const PasswordHint = styled.p`
  color: rgba(255, 186, 140, 0.92);
  font-size: 0.75rem;
  margin: 0 0 0.35rem 0;
  line-height: 1.45;
  font-weight: 400;
`;

export const PasswordResponseMessageContainer = styled(FullColumn)`
  border: 1px solid ${props => props.theme[props.color]};
  color: ${props => props.theme[props.color]};
  text-align: center;
  padding: 5px 0 5px 0;
`;

export const ForgotPasswordButton = styled(Button)`
  color: #ff8c38 !important;
  padding-left: 0;
  margin-top: 0.65rem;
  background-color: transparent !important;
  border: none;
  outline: none;
  font-size: 0.8125rem;
  font-weight: 500;
  cursor: pointer;
  box-shadow: none !important;
  letter-spacing: 0.01em;
  transition: color 0.15s ease;

  &:hover {
    color: #ffb366 !important;
  }
`;

export const NewCustomerSpan = styled.span`
  font-weight: 100;
  color: ${props => props.theme.color_white};
  margin-right: 3px;
`;

export const RegisterButton = styled(Button)`
  margin: 0;
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  color: ${props => props.theme.color_purple} !important;

  &:hover { background-color: transparent; }
`;
